import includes from 'lodash/includes';
import { createAction } from "redux-starter-kit";
import { fetchTrees } from '../services/trees';
import { defaultMapState } from '../config';

export const fetchTreesAction = () => async (dispatch, getState) => {
  const { treesLoading, treesLoaded } = getState();
  if (treesLoading || treesLoaded) return;

  // set loading state
  dispatch(setTreesLoading(true));
  
  // fetch the trees
  const trees = await fetchTrees();

  // populate state
  dispatch(fetchTreesSuccess(trees));

  // set loading states
  dispatch(setTreesLoading(false));
  dispatch(setTreesLoaded(true));

  dispatch(setTreesVisible(true));

}

export const fetchTreesSuccess = createAction('trees/success', trees => ({ payload: { trees } }));

export const setTreesLoading = createAction('trees/loading', loading => ({ payload: { loading } }));
export const setTreesLoaded = createAction('trees/loaded', loaded => ({ payload: { loaded } }));
export const setTreesVisible = createAction('trees/setVisible', visible => ({ payload: { visible } }));
export const setSelecetedTree = createAction('trees/setSelected', treeKey => ({ payload: { treeKey } }));
export const selectTree = (treeKey) => (dispatch, getState) => {
  const { trees } = getState();
  dispatch(setSelecetedTree(treeKey));
  if (treeKey !== null) {
    const tree = trees[treeKey];
    dispatch(setMapCenter({ latitude: tree.lat, longitude: tree.lon }));
    dispatch(setMapZoom(18));
  } else {
    dispatch(setMapZoom(defaultMapState.zoom));
  }
}
export const setTreeSearchVisible = createAction('trees/setSearchVisible', visible => ({ payload: { visible } }));

export const setMapViewport = createAction('map/setViewport', viewport => {
  const excludeKeys = ['transitionDuration', 'transitionEasing', 'transitionInterpolator', 'transitionInterruption'];
  const payload = Object.keys(viewport).filter(key => !includes(excludeKeys, key)).reduce((payload, key) => { payload[key] = viewport[key]; return payload }, {});
  return { payload }
});
export const setMapZoom = createAction('map/setZoom', zoom => ({ payload: { zoom } }));
export const setMapCenter = createAction('map/setCenter', ({ latitude, longitude }) => ({ payload: { latitude, longitude } }));
export const resetMap = createAction('map/reset');
